<template>
  <div class="kpi">
      <Header></Header>
      <div class="container">
          <!-- <h1>أهــم مؤشرات الأداء</h1> -->
          <div class="row">
              <div class="col-lg-6">
                  <div class="chartWrapper">
                    <p>العملاء (بالآلاف)</p>
                    <div class="bgLayer">
                        <div class="chart">
                            <VueApexCharts ref="chart" type="bar" :options="options" :series="series"></VueApexCharts>
                        </div>
                    </div>
                </div>
                
              </div>
              <div class="col-lg-6">
                  <div class="chartWrapper">
                    <p>الأرباح المجمعة قبل خصم الفوائد والضرائب والاستهلاكات (مليون دولار أمريكي) والهامش</p>
                    <div class="bgLayer">
                        <div class="chart">
                            <VueApexCharts ref="chart" type="bar" :options="options3" :series="series3"></VueApexCharts>
                        </div>
                    </div>
                </div>
                
              </div>
              <div class="col-lg-6">
                  <div class="chartWrapper">
                    <p>الإيرادات المجمعة (مليون دولار أمريكي)</p>
                    <div class="bgLayer">
                        <div class="chart">
                            <VueApexCharts ref="chart" type="bar" :options="options2" :series="series2"></VueApexCharts>
                        </div>
                    </div>
                </div>
              </div>
              <div class="col-lg-6">
                  <div class="chartWrapper">
                    <p>صافي الأرباح المجمعة (مليون دولار أمريكي)</p>
                    <div class="bgLayer">
                        <div class="chart">
                            <VueApexCharts ref="chart" type="bar" :options="options4" :series="series4"></VueApexCharts>
                        </div>
                    </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import gsap from "gsap";
export default {
  components: {
    VueApexCharts
  },
  data: function() { 
    return {
        options: {
            chart: {
                width: "100%",
                height: 250,
                id: "vuechart-example",
                foreColor: "#000",
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                },
                toolbar: {
                    show: false,
                    tools: {
                    download: false
                    }
                },
            },
            colors: ['#c1c3c5'],
            xaxis: {
                categories: [
                "2020",
               "2019",
                "2018",
                "2017",
                "2016"
                ]
            },
            grid:{
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                 yaxis: {
                     opposite: true,
                    lines: {
                        show: false
                    }
                }
            },
            dataLabels: {
                style: {
                    colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    columnWidth: '20%',
                     barHeight: '30%',
                }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart:{
                            height: 400
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '70%',
                            }
                        },
                        dataLabels: {
                            style: {
                               colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                            }
                        },
                        legend: {
                            position: "bottom",
                            fontSize: '8px',
                            show: false,
                        }
                    }
                }
            ]
        },
        series: [
            {
                name: "عملاء",
                data: [47764, 49521, 48993, 46608, 47004,]
            }
        ],
        options2: {
            chart: {
                width: "100%",
                height: 350,
                id: "vuechart-example",
                foreColor: "#000",
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                },
                toolbar: {
                    show: false,
                    tools: {
                        download: false
                    }
                },
            },
            colors: ['#c1c3c5'],
            grid:{
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                 yaxis: {
                    lines: {
                        show: false
                    }
                }
            },
            xaxis: {
                categories: [
                "2020",
               "2019",
                "2018",
                "2017",
                "2016"
                ]
            },
            dataLabels: {
                style: {
                    colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    columnWidth: '20%',
                     barHeight: '30%',
                }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart:{
                            height: 400
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '70%',
                            }
                        },
                        dataLabels: {
                            style: {
                               colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                            }
                        },
                        legend: {
                            position: "bottom",
                            fontSize: '8px',
                            show: false,
                        }
                    }
                }
            ]
        },
        series2: [
            {
                name: "الإيرادات",
                data: [5311, 5471, 4362, 3398, 3602,]
            }
        ],
        options3: {
            chart: {
                width: "100%",
                height: 350,
                id: "vuechart-example",
                foreColor: "#000",
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                },
                 toolbar: {
                    show: false,
                    tools: {
                        download: false
                    }
                },
            },
            colors: ['#c1c3c5'],
            grid:{
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                 yaxis: {
                    lines: {
                        show: false
                    }
                }
            },
            xaxis: {
                categories: [
                "2020",
               "2019",
                "2018",
                "2017",
                "2016"
                ]
            },
            dataLabels: {
                style: {
                    colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    columnWidth: '20%',
                     barHeight: '30%',
                }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart:{
                            height: 400
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '70%',
                            }
                        },
                        dataLabels: {
                            style: {
                               colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                            }
                        },
                        legend: {
                            position: "bottom",
                            fontSize: '8px',
                            show: false,
                        }
                    }
                }
            ]
        },
        series3: [
            {
                name: "إبيتدا",
                data: [2198, 2400, 1717, 1367, 1694,]
            }
        ],
        options4: {
            chart: {
                width: "100%",
                height: 350,
                id: "vuechart-example",
                foreColor: "#000",
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                },
                 toolbar: {
                    show: false,
                    tools: {
                        download: false
                    }
                },
            },
           colors: ['#c1c3c5'],
            grid:{
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                 yaxis: {
                    lines: {
                        show: false
                    }
                }
            },
            xaxis: {
                categories: [
                "2020",
               "2019",
                "2018",
                "2017",
                "2016"
                ]
            },
            dataLabels: {
                style: {
                    colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    columnWidth: '20%',
                     barHeight: '30%',
                }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart:{
                            height: 400
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '70%',
                            }
                        },
                        dataLabels: {
                            style: {
                               colors: ["#fff", "#8a8c8e", "#8a8c8e"]
                            }
                        },
                        legend: {
                            position: "bottom",
                            fontSize: '8px',
                            show: false,
                        }
                    }
                }
            ]
        },
        series4: [
            {
                name: "صافي الدخل",
                data: [605, 715, 649, 527, 519,]
            }
        ],
    };
  },
  mounted() {
    this.$refs.chart.destroy();
    this.counterAnimation();
    this.chartAnimation();
  },
  methods: {
    chart: function() {
      this.$refs.chart.init();
    },
    chartAnimation: function() {
      let tl = gsap.timeline();
      tl.from(".chart", {
        opacity: 1,
        scrollTrigger: {
          trigger: ".chart",
          start: "top 90%",
          end: "top 55%",
          markers: false,
          scrub: 1,
          once: true,
          onEnter: ({ progress, direction, isActive }) => this.chart()
        }
      });
    }
  }
};
</script>
<style lang="scss">
    [data-page="kpi"]{
        .verticalLabel{
            color: #fff;
        }
    }
</style>
<style lang="scss" scoped>
    .kpi{
        position:relative;
        padding:100px 0 30px 0;
        .chart{
            direction:ltr;
        }
       &:after{
            content:"";
            position:absolute;
            width:100%;
            height:100%;
            background: url("../../assets/images/banners/kpis-banner.png") right top no-repeat;
            background-size: cover;
            left:0;
            top:0;
            z-index:-1;
            transform:scaleX(-1);
            @media screen and (min-width:992px){
                background-attachment: fixed;
            }
            @media screen and (max-width:1199px){
                background-position-x: 35%;
            }
            @media screen and (max-width:991px){
                background: url("../../assets/images/banners/kpis-banner-responsive.png") right top no-repeat;
                background-size: cover;
                background-position-x: 57%;
                transform:scaleX(-1);
            }
        }
        h1{
            color:#fff;
            @media screen and(max-width:767px){
                font-size:rem(30px);
            }
        }
        .chartWrapper{
            p{
                margin:rem(40px) 0 rem(10px) 0;
                font-size:rem(18px);
                color:#fff;
                font-weight:600;
            }
            
        }
        
        /deep/{
            .apexcharts-text {
                font-weight:600 !important;
                fill:#fff !important;
            }
            .apexcharts-bar-area{
                opacity:1 !important;
                fill:#707070 !important;
            }
        }
        @media screen and (max-width:991px){
            .row{
                > div{
                    margin-bottom:rem(30px);
                }
            }
        }
    }
</style>